import './image-tag.scss'

import classNames from 'classnames'
import _ from 'lodash'
import moment from 'moment'
import React, { useEffect, useState } from 'react'

const ImageTag = ({ article }) => {
  const [tagClass, setTagClass] = useState('')
  const [tagName, setTagName] = useState('')
  useEffect(() => {
    if (article.nodeType === 'UniversityPost') {
      const subcategoryUniversity = _.filter(
        _.get(article, 'categories.nodes'),
        (c) =>
          c.slug.startsWith('advanced') ||
          c.slug.startsWith('beginner') ||
          c.slug.startsWith('intermediate')
      )
      if (_.head(subcategoryUniversity)) {
        setTagClass(classNameCategory(_.head(subcategoryUniversity).slug))
        setTagName(_.head(subcategoryUniversity).name)
      }
    } else if (article.nodeType === 'Event') {
      if (
        !_.isEmpty(_.get(article, 'acf.eventDatetime.endDate'))
          ? moment().unix() <=
            moment(
              _.get(article, 'acf.eventDatetime.endDate'),
              'DD/MM/YYYY'
            ).unix()
          : moment().unix() <
            moment(
              _.get(article, 'acf.eventDatetime.startDate'),
              'DD/MM/YYYY'
            ).unix()
      ) {
        setTagClass('event-upcoming')
        setTagName('UPCOMING')
      }
    }
  }, [article])
  const classNameCategory = (slug) => {
    if (slug) {
      switch (true) {
        case slug.startsWith('intermediate'):
          return 'intermediate'
        case slug.startsWith('advanced'):
          return 'advanced'
        case slug.startsWith('beginner'):
          return 'beginner'
        default:
          break
      }
    }
  }
  return (
    <div
      className={classNames({
        'tag-image': true,
        [`${tagClass}`]: true,
      })}
    >
      <p>{tagName}</p>
    </div>
  )
}

export default ImageTag
